import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataEngine } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeEngineAccordionProps {
  engineData?: EquipmentModelLatestFipeDataEngine
}

export default function FipeEngineAccordion({ engineData }: FipeEngineAccordionProps) {
  return (
    <Accordion
      name="Engine"
      head="Motor"
      defaultOpen
      body={
        <div className="flex flex-col gap-1">
          <div className='flex items-center gap-1'>
            <InfoField label="Instalação" value={engineData?.Instalacao} />
            <InfoField label="Aspiração" value={engineData?.Aspiracao} />
            <InfoField label="Disposição" value={engineData?.Disposicao} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Alimentação" value={engineData?.Alimentacao} />
            <InfoField label="Cilindros" value={engineData?.Cilindros} />
            <InfoField label="Comando de Válvulas" value={engineData?.["Comando Valvulas"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Variação de Comando" value={engineData?.["Variacao Comando"]} />
            <InfoField label="Cilindrada unitária" value={engineData?.["Cilindrada Unitaria"]} />
            <InfoField label="Acionamento de comando" value={engineData?.["Acionamento Comando"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Válvulas por cilindro" value={engineData?.["Valvulas Por Cilindro"]} />
            <InfoField label="Diâmetro do cilindro" value={engineData?.["Diametro Cilindro"]} />
            <InfoField label="Taxa de compressão" value={engineData?.["Razao Compressao"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Curso do pistão" value={engineData?.["Curso Pistao"]} />
            <InfoField label="Deslocamento" value={engineData?.Deslocamento} />
            <InfoField label="Potência máxima" value={engineData?.["Potencia Maxima"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Torque Máximo" value={engineData?.["Torque Maximo"]} />
            <InfoField label="Peso potência" value={engineData?.["Peso Potencia"]} />
            <InfoField label="Torque Específico" value={engineData?.["Torque Especifico"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Peso" value={engineData?.Peso} />
            <InfoField label="Tuchos" value={engineData?.Tuchos} />
            <InfoField label="Código" value={engineData?.Codigo} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Rotação máxima" value={engineData?.["Rotacao Maxima"]} />
            <InfoField label="Autonomia" value={engineData?.Autonomia} />
            <InfoField label="Autonomia Elétrica" value={engineData?.["Autonomia Eletrica"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Capacidade de Bateria" value={engineData?.["Capacidade Bateria"]} />
            <InfoField label="Consumo elétrico" value={engineData?.["Consumo Eletrico"]} />
            <InfoField label="Potência" value={engineData?.Potencia} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Potência combinada" value={engineData?.["Potencia Combinada"]} />
            <InfoField label="Torque" value={engineData?.Torque} />
            <InfoField label="Torque combinado" value={engineData?.["Torque Combinado"]} />
          </div>
          <InfoField label="Velocidade máxima no modo elétrico" value={engineData?.["Velocidade Maxima Modo Eletrico"]} />
        </div>
      }
    />
  )
}